import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'
import '../../components/Home.module.css'
import Registration from './login-form';
import Footer from '../Footer';
import AboutReliable from '../../components/AboutReliable';
import OurStrength from '../../components/OurStrength'
import SeniorDivision from '../../components/CoursesOffered/SeniorDivision'
import JuniorDivision from '../../components/CoursesOffered/JuniorDivision'
import OurAchievements from '../../components/OurAchievements'
import Rotary from '../../components/rotary'
import OurAim from '../../components/OurAim';
import AboutRotary from '../../components/AboutRotary';
// import Video from '../../components/Video';
// import Image from 'https://reliablekota.com/mission-vriksh/Mission-Vriksh-lp-new.png'
const MidHeader = ({ setToken }) => {
  return (
    <>
      <section className='bg-welcome'>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              {/* <div className="row">
                <div className="col-lg-6 col-xs-12">
                  <img src="https://reliablekota.com/reliable-assets/images/reliable-website-new-logo.png" alt="" height={125} width={175} />
                </div>
                <div className="col-lg-6 col-xs-12">
                  <img src="https://reliablekota.com/mission-vriksh/rotary-logo.png" alt="" height={125} width={175} style={{ float: "right" }} />
                </div>
              </div> */}
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }} >
                <img src="https://reliablekota.com/mission-vriksh/rotary-logo.png" alt="" width={"230px"} />
              </div>

              <div className="row">
                <div className="col-lg-6">
                  <img src="https://reliablekota.com/mission-vriksh/Mission-Vriksh-lp-new.png" alt="" style={{ height: "auto", width: "100%", maxWidth: "480px", paddingBottom: "3rem" }} className="img-fluid" />
                </div>
                <br />
                <br />
                <div className="col-lg-6 pb-4" >
                  <div className="cours-bx">
                    <Registration setToken={setToken} />
                  </div>
                </div>
              </div>
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }} >
                <img src="https://reliablekota.com/reliable-assets/images/reliable-website-new-logo.png" alt="" height={125} width={175} />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <Video /> */}
      <OurAim />
      <AboutRotary />
      <AboutReliable />
      <OurStrength />
      <SeniorDivision />
      <JuniorDivision />
      <div className="row">
        <div className="col-lg-6">
          <OurAchievements />
        </div>
        <div className="col-lg-6">
          <Rotary />
        </div>
      </div>
      <Footer />
    </>
  )
}

export default MidHeader;